import DOMPurify, { type Config } from 'dompurify';
import { Marked } from 'marked';

const marked = new Marked({ gfm: true, breaks: true });

const PURIFY_OPTIONS: Config = {
  ALLOWED_TAGS: [
    'a', 'b', 'blockquote', 'br', 'code', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'hr', 'i', 'li', 'ol', 'p', 'pre', 'span', 'strong', 'ul',
  ],
  ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
};

function sanitize(html: string): string {
  return DOMPurify.sanitize(html, PURIFY_OPTIONS);
}

/**
 * Render block-level Markdown (paragraphs, lists, headings, code blocks, etc.).
 * Use for assistant chat bubbles where multi-line output is expected.
 */
export function renderMarkdown(text: string | null | undefined): string {
  if (!text) return '';
  return sanitize(marked.parse(text) as string);
}

/**
 * Render Markdown without block-level wrappers — emphasis, strong, code, and links only.
 * Use for short fields that live inside `<p>` / `<dd>` / inline contexts where a `<ul>`
 * or `<p>` child would produce invalid nesting.
 */
export function renderInlineMarkdown(text: string | null | undefined): string {
  if (!text) return '';
  return sanitize(marked.parseInline(text) as string);
}
